import {Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnInit} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import { PushNotificationService } from '../core/services/push-notification.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppComponent implements OnInit{
  private readonly _pushService: PushNotificationService = inject(PushNotificationService);
  title = 'braidsbook-admin';

  ngOnInit(): void{
    this._pushService.subscribeToNotifications();
    this._pushService.listenToMessages();
  }
}
